import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useReveal, revealClass } from "../hooks/useReveal";

export const Vision = () => {
  const { t } = useLanguage();
  const [secRef, secVisible] = useReveal();

  return (
    <section
      id="vision"
      data-testid="section-vision"
      className="py-32 md:py-44 border-t border-line bg-navy text-white scroll-mt-24 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div ref={secRef} className={revealClass(secVisible)}>
          <p className="section-index !text-white/55 mb-10" data-testid="vision-index">
            {t.vision.index}
          </p>
          <h2
            className="font-serif-display font-light tracking-tightest text-white leading-[1.05] text-4xl sm:text-5xl md:text-6xl lg:text-7xl max-w-5xl"
            data-testid="vision-title"
          >
            “{t.vision.pull}”
          </h2>
          <div className="mt-16 grid grid-cols-12">
            <div className="col-span-12 md:col-span-7 md:col-start-6">
              <p
                className="text-lg md:text-xl text-white/75 font-light leading-relaxed"
                data-testid="vision-body"
              >
                {t.vision.body}
              </p>
              <div className="mt-12 flex items-center gap-4">
                <span className="h-px w-16 bg-white/40" />
                <span className="font-serif-display text-xl text-white">
                  Ivan Bautista
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
